import { graphql } from 'react-relay';

export const GlobalSpaceQuery = graphql`
	query GlobalSpaceQuery($cloudId: ID!) {
		confluence_questionsConfiguration(cloudId: $cloudId) {
			confluenceQuestionsGlobalSpaceKey
			hasConfluenceQuestionsAccess
			confluenceQuestionsGlobalSpaceId
		}
	}
`;
